import React from 'react'



import './Video.css'

//loading-blog.gif
//pokemon.gif
const Video = () => {
    return (
    <>
        <div className='vid-container'>
        <img src='/Abouabdallah/Images/background.gif' alt='background' className='image'/>
          
          <div className='vid-content'>
              <h1> ABOUABDALLAH MOHAMED ANWAR (Phd)</h1>
          </div>
            </div>
    </>
  )
}

export default Video